import { PageLayout } from '@/shared/layout/PageLayout';

export function FuelRatesPage() {
  return (
    <PageLayout title="Module fuel-rates" description="Quản lý fuel-rates">
      <div className="p-4 bg-white rounded-md shadow-sm border border-slate-200">
        <p className="text-slate-500">Not implemented yet</p>
      </div>
    </PageLayout>
  );
}
